import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, Palmtree } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function SubscriptionSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { t } = useTranslation();
  const [status, setStatus] = useState("checking");
  const [planName, setPlanName] = useState("");
  const attempts = useRef(0);

  useEffect(() => {
    const sid = sp.get("session_id");
    if (!sid) { setStatus("error"); return; }
    const poll = async () => {
      try {
        const { data } = await api.get(`/subscription/status/${sid}`);
        setPlanName(data.plan_name);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch (e) { console.error("Subscription status check failed:", e); }
      attempts.current += 1;
      if (attempts.current < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sp]);

  return (
    <div className="section-sand min-h-[70vh] flex items-center justify-center py-16 px-4">
      <div className="bg-white rounded-3xl shadow-card border border-border p-10 max-w-md w-full text-center animate-fade-up">
        {status === "checking" && <p className="text-canard font-body py-10">{t("plans.processing")}</p>}
        {status === "paid" && (
          <>
            <div className="w-20 h-20 rounded-full bg-emeraude/15 flex items-center justify-center mx-auto mb-5">
              <CheckCircle2 className="w-11 h-11 text-emeraude" />
            </div>
            <h1 className="font-heading font-extrabold text-2xl text-ink">{t("plans.activated")}</h1>
            <p className="text-muted2 font-body mt-3">{planName}</p>
            <Button data-testid="sub-back-dashboard" onClick={() => nav("/loueur")} className="mt-6 rounded-full bg-canard hover:bg-canard-dark font-bold w-full">{t("plans.tab")}</Button>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <Palmtree className="w-12 h-12 text-canard mx-auto mb-4" />
            <p className="text-muted2 font-body">{t("plans.processing")}</p>
            <Button onClick={() => nav("/loueur")} className="mt-6 rounded-full bg-canard">{t("plans.tab")}</Button>
          </>
        )}
      </div>
    </div>
  );
}
